module.exports = __webpack_public_path__ + "static/media/11.7865d665.jpeg";